import { _GROUPS } from "@/store/_PERMISSIONS"

// -- FIELDS
const _FIELDS = [
  {
    label: "Nome",
    name: "nome",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    label: "Instituição",
    name: "id_instituicao",
    type: "array",
    store: "instituicao",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  }
]

// -- HEADERS
const _HEADERS = [
  {
    text: "Nome",
    align: "left",
    value: "nome"
  },
  {
    text: "Instituição",
    align: "left",
    value: "instituicao"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const BRIGADA = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default BRIGADA
